import { QueryType } from '../api/interfaces';
import { nortadaLogger } from '../components/common/logger';

const queryTypesMapper = (queryType: string): QueryType => {
  const queryTypesTranslation: Record<string, QueryType> = {
    'Name & Phone number': 'NAME_AND_MSISDN',
    'Name & Bank Account': 'NAME_AND_BANK_ACCOUNT',
    'Phone number & Date of Birth': 'MSISDN_AND_DATE_OF_BIRTH',
    'BVN & Name & Date of Birth': 'BVN_AND_NAME_AND_DATE_OF_BIRTH'
  };

  return queryTypesTranslation[queryType] ?? nortadaLogger.critical(`${queryType} is unsupported query type.`);
};

export default queryTypesMapper;
